import { Box } from '@mui/material';
import { VigoTypography } from 'src/@vigo/vigo-typography';

interface StaticOverlayProps {
  active: boolean;
}

const StaticOverlay: React.FC<StaticOverlayProps> = ({ active }) => {
  if (!active) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.3)',
        zIndex: '99',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        borderRadius: '4px'
      }}>
      <VigoTypography
        value="STATIC"
        sx={{
          textShadow: '1px 1px  9px rgba(0,0,0,0.7)',
          marginLeft: '10px',
          fontSize: '1.4rem',
          fontWeight: 'bold',
          color: '#fff'
        }}
      />
    </Box>
  );
};

export default StaticOverlay;
